import {Button, Card, Input, List, Space, Table, Typography} from "antd";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import Helper from "../../core/Helper";
import {useUser} from "../../core/context/UserContext";

export default function UnitList()
{
    const history = useHistory();
    const [units, setUnits] = useState([]);
    const [filteredData, setFilteredData] = useState([])
    const {firmSettings} = useUser();

    const getUnits = async () => {
        const res = await ApiService.Unit.GetUnitList();

        if(res.success)
        {
            setUnits(res.data);
        }
    }

    const deleteUnit = async (unitId) => {
        const res = await ApiService.Unit.DeleteUnit(unitId);
        if(res.success)
        {
            await getUnits();
        }
    }

    useEffect(() => {
        getUnits()
    }, [])

    useEffect(() => {
        setFilteredData(units)
    }, [units])

    const upload = async (unitId) => {
        const resFile = await Helper.File.getFileAsBase64({accept: '*.docx'});
        if(resFile.data)
        {
            const res = await ApiService.Unit.UploadDefaultForm(unitId, {
                fileBase64: resFile.data
            });
        }
    }

    const download = async (unitId) => {
        const res = await ApiService.Unit.GetDefaultForm(unitId);
        if(res.success)
        {
            Helper.File.saveFile({
                blobLink: res.data,
                fileName: res.fileName
            })
        }
    }

    const renderAction = (row) => {
        return (
            <Space>
                <a key="edit" href={`/app/system/units/edit/${row.id}`}>{t('Edit')}</a>
                |
                {/*<a key="form-upload" onClick={() => upload(row.id)}>{t('Upload Onam Form')}</a>*/}
                {/*|*/}
                {/*<a key="form-download" onClick={() => download(row.id)}>{t('Download Form')}</a>*/}
                {/*|*/}
                <a key="delete" onClick={async () => {await deleteUnit(row.id)}} style={{color: 'red'}}>{t('Delete')}</a>
            </Space>
        )
    }

    return (
        <SimpleLayout fullWidth={true}>
            <Card>
                <Space style={{marginBottom: 16}}>
                    <Button size={'small'} onClick={() => {history.push(`/app/system/units/create`)}} type={'primary'}>{t('New')}</Button>
                    <Button size={'small'} onClick={getUnits}>{t('Refresh')}</Button>
                    <Input
                        size={'small'}
                        placeholder={t('Search')}
                        onChange={(e) => {
                            if(!e.target.value)
                            {
                                setFilteredData(units);
                                return
                            }
                            setFilteredData(units.filter(x => x.name.toLocaleUpperCase(firmSettings?.locale).includes(e.target.value.toLocaleUpperCase(firmSettings?.locale))))
                        }}
                    />
                </Space>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    rowKey={'id'}
                    columns={[
                        {key: 'name', dataIndex: 'name', title: t('Name')},
                        {key: 'firm', dataIndex: 'firm', title: t('Firm'), render: (text, row) => row?.firm?.name},
                        {key: '#', dataIndex: '#', title: '#', render: (text, row) => renderAction(row)},
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}
